if (!customElements.get('ravin-filters')) {
  // Search & Discovery color groups verified on 2026-10-03. Update after regrouping colors.
  const colorGroups = {"524460":["ARMY BLACK","B.BLACK","Black","BLACK","Black & White","BLACK BIRD","BLACK ELEPHANT","BLACK FLORAL","BLACK FLOWER","BLACK PLIED","Black Sport","BLACK STRIPE","BLACK WASH","BLACK- BLACK - GRAY","BLACK- PETROL-GREY","Black-1","BLACK-1","Black-2","BLACK-2","Black-3","BLACK-3","Black-4","BLACK-4","BLACK-5","BLACK-BASIC","BLACK-GOLD","BLACK-WHITE","BLACK1","BLACK2","BLACK5","BLACKGR BROWN","BLACKGR GREEN","BLUE BLACK","BLUE.BLACK","GRAY BLACK WHITE","H BLACK","H.Black","H.BLACK","J.BLACK","L.BLACK","NAVY-BLACK-WHITE","SHINE BLACK","SHINING BLACK"],"557228":["Blue","BLUE","BLUE JEANS","BLUE MIRROR","BLUE STRIPE","BLUE TERQ","BLUE TERQ.","BLUE- HAVAN","BLUE.TERQ","BLUE1","BLUE2","C.L.BLUE","CHAMBRAY D.J.BLUE","CHAMBRAY J.BLUE","CLBLUE","COR BLUE","D. BLUE","D.Blue","D.BLUE","D.BLUE6","D.H.BLUE","D.H.JEANS BLUE","D.J.Blue","D.J.BLUE","D.JEANS BLUE","GREY-WHITE- BLUE","H.BLUE","H.BLUE TERQ.","H.D.BLUE","H.D.J.BLUE","H.J.BLUE","H.JEANS BLUE","H.L.Blue","H.L.BLUE","H.M.BLUE","H.R.BLUE","H.S.BLUE","H.SKY BLUE","ICE BLUE","ICE JEANS BLUE","Ice.Blue","ICE.BLUE","J BLUE","J. BLUE","J.Blue","J.BLUE","J.BLUE (BROWN)","J.BLUE (ORANGE)","J.BLUE WASH","JEANS BLUE","Blue 1"],"589996":["B.JEANS","JEANS","L .J .BLUE","L. BLUE","L.Blue","L.BLUE","L.BLUE5","L.H.BLUE","L.J.Blue","L.J.BLUE","L.JEANS BLUE","L.R.BLUE","L.SKY BLUE","LAKE BLUE","LT.BLUE","M.BLUE","M.J.Blue","M.J.BLUE","R BLUE","R. BLUE","R.Blue","R.BLUE","RAW DENIM","RAW JEANS","RAW JEANS BLUE","ROYAL BLUE","S.BLUE","Sk.Blue","SK.BLUE","SKY BLUE","SKY.BLUE","ULTRA J.BLUE","Blue 2"],"688300":["BRN","BROWN","BROWN-BASIC","BROWN-YELL","BROWN2","BRWON","Camel","CAMEL","CAMEL YELLOW","CAMELPURPLE","COFEE","COFFE","COFFEE","COFFEE FLOWER","COFFEE1","COFFEE3","D.BROWN","D.BROWN2","D.BROWN3","D.CAMEL","D.COFFEE","D.H..BROWN","GRADIENT BROWN","H.BROWN","H.CAMEL","H.COFFE","H.COFFEE","H.D.BROWN","H.L.Brown","H.L.BROWN","H.L.BROWN-1","H.L.BROWN-2","H.L.COFFEE","l.BROWN","L.Brown","L.BROWN","L.CAMEL","L.COFFE","l.COFFEE","L.Coffee","L.COFFEE","M.Brown","M.BROWN","M.Coffee","M.COFFEE","NAVY BROWN","TIGER BROWN","TIGER COFFEE","Brown"],"852140":["BURG","BURG DOTS","BURG.","BURGUNDY","D BURG","D H BURG","D. BURG","D.BURG","D.BURGUNDY","D.H.BURG","H.BURG","H.BURG.","H.BURGUNDY","H.D.BURG","H.L.Burg","H.L.BURG","J.Burg","l.BURG","L.Burg","L.BURG","L.BURGUNDY","Burg"],"1048748":["GOLD","GOLD MIRROR","GOLD OXIDE","GOLD PEARL","GOLDFLASH","GOLDGR PURPLE","GOLDMINT","GOLDSMOKE","Gold"],"622764":["A.GREEN","AMY GREEN","ARMY GREEN","BRN TO GREEN","D.GREEN","D.H.GREEN","D.M.GREEN","D.MINT GREEN","D.MINT.GREEN","D.Mnt Green","D.MNT GREEN","D.MNT.GREEN","D.MntGreen","D.MNTGREEN","DH.MINT GREEN","FLASH GREEN","FLASH.GREEN","GOLDGR GREEN","Green","GREEN","GREEN PRINT","H.D.GREEN","H.D.M.GREEN","H.D.MINT.GREEN","H.D.Mnt Green","H.FLASH GREEN","H.GREEN","H.GREEN-1","H.GREEN-2","H.L.GREEN","H.L.MNT.GREEN","H.M.GREEN","H.MINT GREEN","H.MINT.GREEN","H.MNTGREEN","IT.GREEN","L. GREEN","L.Green","L.GREEN","L.M.GREEN","L.MINT GREEN","L.MINT.GREEN","L.Mnt Green","L.MNT GREEN","L.MNTGREEN","LH.GREEN","LIME GREEN","LM.GREEN","M.Green","M.GREEN","Green 1"],"655532":["MENT GREEN","MINT","MINT GREEN","Mint.Green","Mnt Green","MNT GREEN","MntGreen","MNTGREEN","Neon Green","NEON GREEN","NEON.GREEN","ROYAL GREEN","S.MINT.GREEN","TIGER GREEN","U.L. GREEN","U.L.MINT.GREEN","U.L.Mnt Green","U.L.MNT GREEN","Y. GREEN","Y.GREEN","YELLOW GREEN","Green 2"],"753836":["Charcoal Grey","COLORFUL GREY","D.Grey","D.GREY","D.Grey-1","D.GREY-1","D.GREY-2","D.GREY-3","D.GREY-4","D.GREY2","D.H,GREY","D.H. GREY","D.H.GREY","D.H.GREY-2","DH.GREY","DK GREY","DK.GREY","Grey","GREY","GREY PRINT","GREY STSR","GREY WHITE","GREY3","H.D.Grey","H.D.GREY","H.D.GREY-1","H.D.GREY-2","H.D.GREY-3","H.D.GREY-4","H.D.GREY-5","H.Grey","H.GREY","H.GREY-1","H.GREY-3","H.L.Grey","H.L.GREY","H.L.GREY-1","H.L.GREY-2","H.L.GREY-3","H.L.GREY-4","H.M.GREY","L-H-GREY","L. H. GREY","L.Grey","L.GREY","L.GREY-1","L.GREY-2","L.GREY-3","L.GREY-4","L.GREY-5","Grey 1"],"786604":["D. GRAY","D.GRAY","D.H.GRAY","DARK GRAY","Gray","GRAY","H. GRAY","H.D.GRAY","H.GRAY","H.L.GRAY","L GRAY","L.GRAY","L.H.GRAY","L.H.GREY","L.H.GREY-1","L.H.GREY-2","L.H.GREY-3","L.H.GREY-4","L.H.GREY-5","LH.GREY","M.GRAY","m.grey","M.Grey","M.GREY","M.GREY1","M.GREY2","MH.GREY","TIGER GREY","Grey 2"],"917676":["D.H.KHAKI","D.KAKI","D.KHAKI","DH.KAKI","H. KHAKI","H.Kaki","H.KHAKI","H.L.KHAKI","h.m.khaki","H.M.Khaki","H.M.KHAKI","KAHKI","KAKAI","KAKI","Khaki","KHAKI","KHAKI1","KHKAI","L. KHKAI","L.KHAKI","M.H.KHAKI","M.Khaki","M.KHAKI","M.KHAKI-1"],"360620":["BEIGE/BLACK","BEIGE/BROWN","BEIGE/COFFEE","BEIGE/FUSCHIA","BEIGE/ORANGE","BLACK / HAVAN","BLACK/BLACK","BLACK/BLUE","Black/Blue Line","BLACK/CHAMPAIGN","BLACK/D.GREY","BLACK/D.ORANGE","BLACK/FUSHIA NEON","BLACK/GOLD","BLACK/GRADIENT BLACK LENS","BLACK/GRAY","Black/Gray Line","BLACK/GREY","BLACK/HAVAN","BLACK/PINK","BLACK/RED","BLACK/SILVER","BLACK/SMOKING GREY","BLACK/TERQ","Black/White","BLACK/WHITE","BLACK/YELLOW","BLK/GREEN FLOWER","BLUE/GREEN","BLUE/HAVAN","BLUE/PURPLE","BLUE/TURQ","Blue/White/Black","BLUE/YELLOW","BROWN/BLACK/WHITE","BROWN/BURG","BROWN/D.GREY","BROWN/FOUSHIA","BROWN/GRADIENT BROWN LENS","BROWN/GREEN","BROWN/KHAKI","BROWN/NAVY","BROWN/SEWING","BROWN/SEWING MIDDLE","BROWN/TERQ","BROWN/TREQ","BROWN/YELLOW","BURG/BLACK","BURG/GREEN","CAMEL/BEIGE","Multi 1"],"393388":["CAMEL/BURG","CAMEL/NAVY","CAMEL/TREQ","D.GREY/BLACK","D.GREY/D.GREY","D.OLIVE/NAVY","D.TREQ/NAVY","DEMI/BEIGE","FUSCHIA/BLACK","FUSCHIA/MINT","FUSCHIA/SILVER","FUSHIA/BLACK LINING","FUSHIA/D.GREY","FUSHIA/GOLD","GOLD/BLACK","GOLD/BLUE","GOLD/BROWN","GOLD/GREEN","GRAY/BINK","GRAY/BLACK","GRAY/BLACK/WHITE","GRAY/WHITE/BLUE","GREEN/D.BROWN","GREY/BLACK","Grey/Brown","GREY/PEACH","GUN/GRREN","GUN/SMOKING GREY","H.NAVY/H.GRAY","H.NAVY/L.H.GRAY","IVORY/BLUSH","LBLUE/PINK","NAVY/BEIGE","NAVY/BLUE","NAVY/BROWN","NAVY/COFFEE","NAVY/D.GREY","NAVY/GREY","NAVY/KHAKI","NAVY/PINK","NAVY/TERQ","O.WHITE/PINK","ORANGE/ BLUE","RANDOM WASH /BLACK","RANDOM WASH /J.BLUE","RED/BLACK","RED/GREY","RED/NAVY","RED/ORANGE","RED/WHITE","Multi 2"],"426156":["BLACK *WHITE","BLACK*BURG","BLACK*GOLD","BLACK*RED","BLACK*TIGER","BLACK*WHITE","BROWN*BLACK","BROWN*HAVAN","FOUSHIA*SILVER","GRAY*WHITE","H.GREY*WHITE","H.NAVY*WHITE","HAVAN*TIGER","JASPER","MULTI COLOR","MULTI COLOR STRIPE","MULTI COLOR1","multi.c","Multi.C","MULTI.C","Multi.C-1","MULTI.C-1","MULTI.COLOR","Multicolor","MULTICOLOR","TERQ/TERQ/FOUSHIA","TURQ/NAVY","WHITE / BLACK","WHITE PATTERN/BUTTERFLY","WHITE PATTERN/HEARTS","WHITE*BLACK","WHITE*BLUE","WHITE*YELOW","WHITE/BEIGE","White/Black","WHITE/BLACK","WHITE/BLACK-TIGER","WHITE/BROWN","WHITE/GOLD","WHITE/GRAY/BLACK","WHITE/GRAY/PINK","WHITE/NAVY/GRAY","WHITE/PINK","WHITE/RED","WHITE/SILVER","WHITE/YELLOW/STRIPE","WHT/RED FLOWER","YELLOW/BLACK-TIGER","YELLOW/BLUE","YELLOW/FUSCHIA","Multi 3"],"819372":["C.NAVY","CHECK NAVY","D.NAVY","DH.NAVY","H NAVY","H. NAVY","H.Navy","H.NAVY","H.Navy-1","H.NAVY-1","H.NAVY-2","H.NAVY-3","H.NAVY-4","H.NAVY-5","H.NAVY-6","NANY","Navy","NAVY","NAVY DOTS","NAVY FLORAL","Navy-1","NAVY-1","Navy-2","NAVY-2","NAVY-3","NAVY-4","NAVY-5","NAVY-NAVY- GRAY","NAVY-STRIPE","NAVY1","NAVY3","RANDOM WASH NAVY"],"458924":["AS PHOTO BEIGE","BEIGE","BEIGE OWL","BEIGE X BROWN","BEIGE-2","BEIGE1","BEIGE2","BEIGE5","BIEGE","BROWN-BEIGE","CHAMBRAY D.BEIGE","CREAM","D.Beige","D.BEIGE","H. OFF WHITE","H.BEIGE","H.BEIGE-1","H.BEIGE-2","H.L.BEIGE","H.O.White","H.O.WHITE","H.OFF WHITE","H.OFF-WHITE","H.OFF.WHITE","H.OFFWHITE","L BEIGE","l.beige","L.Beige","L.BEIGE","L.BIEGE","L.H.BEIGE","OFF WHITE","OFF WJITE","OFF-WHITE","OFF.WHITE","OFF.WHITE DOTS","OFF.WHITE-STRIPE","OFFWHITE","Off White"],"983212":["D.OLIVE","DARK OLIVE","GINGER","H-OLIVE","H.L.OLIVE","H.OLIVE","L.OLIVE","Olive","OLIVE","ULTRA L.OLIVE"],"1015980":["D.ORANGE","DARK ORANGE","H.L.ORANGE","H.MANGO","H.MUSTARD","H.MUSTARD.GOLD","H.ORANGE","L H ORANGE","L.Orange","L.ORANGE","LIGHT ORANGE","M.Orange","M.ORANGE","MANGO","MUSTARD","MUSTARD GOLD","MUSTARD.GOLD","MUSTARDA","MUSTERD GOLD","MUSTRAD","Musturd","MUSTURD","Musturd-1","NEON ORANGE","NEON.ORANGE","Orange","ORANGE","Orange Neon","ORANGE NEON","R.ORANGE"],"1114284":["D. PETROL","D.PETROL","DH.PETROL","H.D.PETROL","H.L.PETROL","H.PETROL","L.H.PETROL","L.PETROL","L.PETROL1","M.PETROL","PETROL","Petrol"],"491692":["BINK","D.H.ROSE","D.Pink","D.PINK","D.Rose","D.ROSE","D.ROSE-1","D.ROSE-2","D.SEIMONE","D.SIMONE","DUSTY PINK","FLACK PINK","FLASH PINK","GOLD PINK","H.D.ROSE","H.L.PINK","H.L.ROSE","H.PINK","H.ROSE","H.SEIMONE","L.H.PINK","L.H.ROSE","L.Pink","L.PINK","L.Rose","L.ROSE","L.SEIMON","L.SEIMONE","L.SIMON","L.Simone","L.SIMONE","LT.PINK","M.Pink","M.PINK","M.PINK1","M.Rose","M.ROSE","NEON PINK","NEON.PINK","Pink","PINK","PINK FLOWER","ROSE","SEIMON","SEIMONE","SIMON"],"884908":["CHECK PURPLE","D.FOUCSHIA","D.FOUHSHIA","D.FOUSCHIA","D.Foushia","D.FOUSHIA","D.FUSHIA","D.H.FOUSHIA","D.H.PURPLE","D.K.PURPLE","D.PURLE","D.Purple","D.PURPLE","DH.PURPLE","FOUCHIA","FOUCSHIA","FOUSCHIA","FOUSCHIA NEON","FOUSHA","FOUSHCIA","FOUSHIA","FUCHSIA","FUCSHIA","FUSCHIA","FUSHIA","H.D.FOUSHIA","H.D.PURPLE","H.FOUSHIA","H.L.PURPLE","H.L.PURPLE-1","H.L.PURPLE-2","H.PURPLE","L.FOUSCHIA","L.Foushia","L.FOUSHIA","L.FUSHIA","L.H.PURPLE","L.PURBLE","L.Purple","L.PURPLE","L.Purple-1","L.PURPLE-1","M.Purple","M.PURPLE","NEON FOUSHIA","PURLPE","Purple","PURPLE","R.FOUCSHIA","U.L.PURPLE"],"327852":["BLUE/RED","BROWN / RED","COFFEE/RED ORANGE","D.GREY/RED","D.RED","DEMI/RED","GREEN CHECKERED","GREY/RED","H,RED","H.L.W.Red","H.RED","H.RED.FOUSHIA","H.U.L.W.RED","H.U.RED","H.W.RED","HAVAN*RED-LEATHER","L.H.RED","L.RED","L.U.LW.RED","L.W.RED","MUSTARED","NAVY/D.RED","NAVY/RED","NAVYRED","Red","RED","RED CAMEL","RED CHECKERED","RED DOTS","RED FOUSHIA","RED ORANGE","RED STRIPE","RED TRIBLE","Red-2","RED.ORANGE","RED/BEIGE","SILVER RED","TIGER RED","U.L.H.W.RED","U.L.W RED","U.L.W.RED","U.W.L.RED","U.W.RED","UI.W.RED","W RED","W.Red","W.RED","W.RED1","WARM RED","WARM RED1"],"1081516":["D. TERQ","D.TER","D.Terq","D.TERQ","H.D.TERQ","H.TERQ","H.TERQ.","L.Terq","L.TERQ","L.TERQ.","TERL","TERQ","TERQ DOTS","WATERMELON","Turquoise"],"721068":["H.WHITE","O WHITE","O.White","O.WHITE","O.White-1","O.WHITE-1","white","White","WHITE","WHITE FLORAL","WHITE- SILVER","White-1","WHITE-1","White-2","WHITE-2","White-3","WHITE-3","White-4","WHITE-4","White-5","WHITE-5","White-6","WHITE-6","White-7","WHITE-7","WHITE-ARMY","WHITE1","WHITE2"],"950444":["D.Yellow","D.YELLOW","H.D.YELLOW","H.L.YELLOW","H.YELLOW","L.W.YELLOW","L.Yellow","L.YELLOW","M.Yellow","M.YELLOW","M.YELLOW-1","M.YELLOW-2","M.YELLOW-3","NEON YELLOW","NEON- YELLOW","YELLOW","Yellow"]};
  customElements.define('ravin-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const resetPage = (url) => {
        for (const key of Array.from(url.searchParams.keys())) {
          if (key === 'page' || key.startsWith('page_') || key === 'ravin_page') url.searchParams.delete(key);
        }
        return url;
      };

      const currentUrl = new URL(window.location.href);
      const desiredMin = currentUrl.searchParams.get('ravin.price.gte');
      const desiredMax = currentUrl.searchParams.get('ravin.price.lte');
      const availabilitySupported = this.dataset.ravinAvailabilitySupported === 'true';

      if (availabilitySupported && currentUrl.searchParams.get('filter.v.availability') !== '1') {
        resetPage(currentUrl);
        currentUrl.searchParams.set('filter.v.availability', '1');
        window.location.replace(currentUrl.toString());
        return;
      }

      if (!availabilitySupported) currentUrl.searchParams.delete('filter.v.availability');

      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-filter-link], a[data-clear-all], a[data-clear-price]');
        if (link?.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();

        const clearPrice = link.hasAttribute('data-clear-price');
        const clearAll = link.hasAttribute('data-clear-all');
        const url = resetPage(new URL(clearPrice ? window.location.href : link.href));

        if (clearPrice || clearAll) {
          for (const key of ['filter.v.price.gte', 'filter.v.price.lte', 'ravin.price.gte', 'ravin.price.lte']) {
            url.searchParams.delete(key);
          }
        } else {
          for (const key of ['ravin.price.gte', 'ravin.price.lte']) {
            if (!url.searchParams.has(key) && currentUrl.searchParams.has(key)) {
              url.searchParams.set(key, currentUrl.searchParams.get(key));
            }
          }
        }

        if (availabilitySupported) url.searchParams.set('filter.v.availability', '1');
        else url.searchParams.delete('filter.v.availability');

        for (const key of ['q', 'type', 'options[prefix]', 'sort_by', 'preview_theme_id']) {
          if (!url.searchParams.has(key) && currentUrl.searchParams.has(key)) {
            url.searchParams.set(key, currentUrl.searchParams.get(key));
          }
        }
        window.location.assign(url.toString());
      });

      const sort = this.querySelector('[data-sort-select]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = resetPage(new URL(window.location.href));
          url.searchParams.set('sort_by', sort.value);
          window.location.assign(url.toString());
        });
      }

      const form = this.querySelector('[data-price-form]');
      if (form) {
        const min = form.querySelector('input[name="filter.v.price.gte"]');
        const max = form.querySelector('input[name="filter.v.price.lte"]');
        if (min && max) {
          if (desiredMin !== null) min.value = desiredMin;
          if (desiredMax !== null) max.value = desiredMax;

          if (desiredMin !== null || desiredMax !== null) {
            const details = this.querySelector('details');
            if (details) details.open = true;
            this.querySelectorAll('[data-clear-price]').forEach((link) => { link.hidden = false; });
            const nativeSummary = this.querySelector('[data-native-price-summary]');
            if (nativeSummary) {
              const removeText = nativeSummary.querySelector('.visually-hidden')?.textContent || '';
              const summaryText =
                (min.labels[0]?.textContent.trim() || '') + ' ' + (desiredMin || '0') +
                (desiredMax !== null ? ' – ' + (max.labels[0]?.textContent.trim() || '') + ' ' + desiredMax : '');
              nativeSummary.textContent = summaryText + ' ';
              const removeMark = document.createElement('span');
              removeMark.setAttribute('aria-hidden', 'true');
              removeMark.textContent = '×';
              const accessibleText = document.createElement('span');
              accessibleText.className = 'visually-hidden';
              accessibleText.textContent = removeText;
              nativeSummary.append(removeMark, accessibleText);
            }
            const fallbackActive = this.querySelector('[data-fallback-active]');
            if (fallbackActive) {
              fallbackActive.hidden = false;
              const fallbackSummary = fallbackActive.querySelector('[data-price-summary]');
              if (fallbackSummary) {
                fallbackSummary.textContent += ': ' + (min.labels[0]?.textContent.trim() || '') + ' ' + (desiredMin || '0') +
                  (desiredMax !== null ? ' – ' + (max.labels[0]?.textContent.trim() || '') + ' ' + desiredMax : '');
              }
            }
          }

          form.addEventListener('input', () => max.setCustomValidity(''));
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            max.setCustomValidity('');
            if (min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber) {
              max.setCustomValidity((min.labels[0]?.textContent.trim() || 'Minimum') + ' ≤ ' + (max.labels[0]?.textContent.trim() || 'Maximum'));
            }
            if (!form.reportValidity()) return;

            const url = resetPage(new URL(window.location.href));
            const maximumDiscount = Math.min(100, Math.max(0, Number(this.dataset.ravinMaxDiscount) || 0));

            if (min.value === '') {
              url.searchParams.delete('ravin.price.gte');
              url.searchParams.delete('filter.v.price.gte');
            } else {
              url.searchParams.set('ravin.price.gte', String(min.valueAsNumber));
              url.searchParams.set('filter.v.price.gte', String(min.valueAsNumber));
            }

            if (max.value === '') {
              url.searchParams.delete('ravin.price.lte');
              url.searchParams.delete('filter.v.price.lte');
            } else {
              url.searchParams.set('ravin.price.lte', String(max.valueAsNumber));
              if (maximumDiscount >= 100) {
                url.searchParams.delete('filter.v.price.lte');
              } else {
                const broadMaximum = Math.ceil((max.valueAsNumber / (1 - maximumDiscount / 100)) * 100) / 100;
                url.searchParams.set('filter.v.price.lte', String(broadMaximum));
              }
            }
            window.location.assign(url.toString());
          });
        }
      }

      this.ravinResultsRoot = this.closest('[data-ravin-results-root]');
      if ([...currentUrl.searchParams.keys()].some((key) => key.startsWith('filter.v.option.'))) {
        this.ravinInitialHidden = [...(this.ravinResultsRoot?.querySelector('[data-ravin-price-grid]')?.children || [])];
        this.ravinInitialHidden.forEach((child) => { child.hidden = false; });
      }
      this.ravinPageHandler = async (event) => {
        const pageLink = event.target.closest('a[data-ravin-client-page]');
        if (!pageLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        window.history.pushState({}, '', pageLink.href);
        const pageRendered = await this.filterRenderedResults();
        if (!pageRendered) return;
        const root = this.ravinResultsRoot;
        if (!root || !root.isConnected) return;
        const stickyHeader = document.querySelector('sticky-header') || document.querySelector('.shopify-section-header-sticky');
        const headerBounds = stickyHeader?.getBoundingClientRect();
        const headerOffset = headerBounds && headerBounds.top <= 0 && headerBounds.bottom > 0 ? headerBounds.bottom : 0;
        const top = Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerOffset - 12);
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.ravinResultsRoot?.addEventListener('click', this.ravinPageHandler);

      this.ravinPopstateHandler = () => this.filterRenderedResults();
      window.addEventListener('popstate', this.ravinPopstateHandler);

      // Phase 3.5 Step 2: prepare stock-aware filter counts on first opening,
      // only if initial collection index loading was safely deferred.
      this.ravinFilterDetails = this.querySelector('details');
      this.ravinDetailsHandler = () => {
        if (this.ravinDeferredIndex && this.ravinFilterDetails?.open) {
          this.ravinDeferredIndex = false;
          this.filterRenderedResults();
        }
      };
      this.ravinFilterDetails?.addEventListener('toggle', this.ravinDetailsHandler);

      this.filterRenderedResults();
    }

    disconnectedCallback() {
      this.ravinResultsRoot?.removeEventListener('click', this.ravinPageHandler);
      if (this.ravinPopstateHandler) window.removeEventListener('popstate', this.ravinPopstateHandler);
      this.ravinFilterDetails?.removeEventListener('toggle', this.ravinDetailsHandler);
    }

    async filterRenderedResults() {
      const root = this.closest('[data-ravin-results-root]');
      const grid = root?.querySelector('[data-ravin-price-grid]');
      if (!root || !grid) return false;

      const renderVersion = (this.ravinRenderVersion || 0) + 1;
      this.ravinRenderVersion = renderVersion;
      const url = new URL(window.location.href);
      const minValue = url.searchParams.get('ravin.price.gte');
      const maxValue = url.searchParams.get('ravin.price.lte');
      const minCents = minValue === null || minValue === '' ? null : Math.round(Number(minValue) * 100);
      const maxCents = maxValue === null || maxValue === '' ? null : Math.round(Number(maxValue) * 100);
      const hasDiscountedRange = minCents !== null || maxCents !== null;
      const hasVariantFilters = [...url.searchParams.keys()].some((key) => key.startsWith('filter.v.option.'));
      const hasDirectVariantFilters = [...url.searchParams.entries()].some(([key, value]) =>
        key.startsWith('filter.v.option.') && !value.startsWith('gid://shopify/FilterSettingGroup/')
      );
      // On editorial collection grids Shopify paginates raw products first,
      // then Liquid removes sold-out cards. Refill available cards from later
      // source pages so 26 slots truly represent 26 in-stock products.
      // Normal search grids retain the previous lightweight path.
      const mustBackfillAvailable = grid.hasAttribute('data-rve-grid') &&
        Number(grid.dataset.ravinPageSize) === 26;
      if (!hasDiscountedRange && !hasDirectVariantFilters && !mustBackfillAvailable) {
        this.ravinInitialHidden?.forEach((child) => { child.hidden = false; });
        this.ravinInitialHidden = null;
        return true;
      }

      // Phase 3.5 Step 2: an unfiltered, fully stocked Shopify first page
      // already contains its final cards and native pagination. Avoid
      // requesting the complete product index merely to redraw this page.
      // Index validation remains mandatory for sparse pages, uncertain stock,
      // variant/discount filters, price sorting and opened filter panels.
      const initialCards = grid.querySelectorAll(':scope > [data-ravin-price-card]');
      const sourcePageSize = Number(grid.dataset.ravinPageSize);
      const hasOtherShopifyFacets = [...url.searchParams.keys()].some(
        (key) => key.startsWith('filter.') && key !== 'filter.v.availability'
      );
      const hasPageNavigation = [...url.searchParams.keys()].some(
        (key) => key === 'page' || key === 'ravin_page' || key.startsWith('page_')
      );
      const hasDiscountedSort = ['price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by'));
      const serverPageComplete =
        mustBackfillAvailable && !hasDiscountedRange && !hasVariantFilters &&
        !this.ravinInitialHidden && !this.ravinFilterCache &&
        this.dataset.ravinAvailabilitySupported === 'true' &&
        url.searchParams.get('filter.v.availability') === '1' &&
        !hasOtherShopifyFacets && !hasPageNavigation && !hasDiscountedSort &&
        this.ravinFilterDetails && !this.ravinFilterDetails.open &&
        !(window.Shopify && window.Shopify.designMode) &&
        sourcePageSize === 26 && initialCards.length === sourcePageSize &&
        Array.from(initialCards).every((card) =>
          !card.hidden && card.dataset.ravinStockConfirmed === 'true');

      if (serverPageComplete) {
        this.ravinDeferredIndex = true;
        return true;
      }
      this.ravinDeferredIndex = false;

      const normalizeOption = (value) => String(value ?? '').trim().toLowerCase();
      const optionMatches = (option, values) => values.some((value) => normalizeOption(value) === normalizeOption(option));
      const clientPage = Math.max(1, Number.parseInt(url.searchParams.get('ravin_page') || url.searchParams.get('page') || '1', 10) || 1);
      const pageSize = Math.max(1, Number(grid.dataset.ravinPageSize) || 24);
      const sourceKeyUrl = new URL(url);
      for (const key of Array.from(sourceKeyUrl.searchParams.keys())) {
        if (key === 'ravin_page' || key === 'page' || key.startsWith('page_')) sourceKeyUrl.searchParams.delete(key);
      }
      const cacheKey = sourceKeyUrl.toString() + '::' + url.searchParams.toString();
      if (!this.ravinFilterCache || this.ravinFilterCache.key !== cacheKey) {
        this.ravinFilterCache = { key: cacheKey, matches: null, cards: new Map(), loadedPages: new Set(), exhausted: true };
      }
      const cache = this.ravinFilterCache;
      const readCards = (documentRoot) => {
        let lastCard = null;
        for (const child of documentRoot.querySelector('[data-ravin-price-grid]')?.children || []) {
          if (child.matches('[data-ravin-price-card]')) {
            lastCard = { html: child.outerHTML, editorials: [] };
            cache.cards.set(child.dataset.ravinProductId, lastCard);
          } else if (!hasDiscountedRange && lastCard && child.matches('[class*="ai-editorial-row-"]')) {
            lastCard.editorials.push(child.outerHTML);
          }
        }
      };
      if (![...url.searchParams.keys()].some((key) => key.startsWith('filter.v.option.'))) readCards(document);
      cache.loadedPages.add(Number(url.searchParams.get('page') || 1));
      const sourcePageUrl = (page, index = false) => {
        const pageUrl = new URL(sourceKeyUrl);
        pageUrl.searchParams.set('page', String(page));
        if (index) pageUrl.searchParams.set('section_id', 'ravin-results-index');
        return pageUrl.toString();
      };
      root.setAttribute('aria-busy', 'true');
      try {
        if (!cache.matches) {
          const loadIndex = async (page) => {
            const response = await fetch(sourcePageUrl(page, true), { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Unable to load product index');
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const payload = parsed.querySelector('[data-ravin-results-index]');
            if (!payload) throw new Error('Product index missing');
            return JSON.parse(payload.textContent);
          };
          const first = await loadIndex(1);
          const indices = [first];
          for (let page = 2; page <= first.pages; page += 4) {
            const batch = [];
            for (let next = page; next < page + 4 && next <= first.pages; next += 1) batch.push(loadIndex(next));
            indices.push(...await Promise.all(batch));
          }
          const normalize = (value) => String(value).trim().toLowerCase();
          const tags1 = (this.dataset.ravinGroup1Tags || '').split(',').map(normalize).filter(Boolean);
          const tags2 = (this.dataset.ravinGroup2Tags || '').split(',').map(normalize).filter(Boolean);
          const tags3 = (this.dataset.ravinGroup3Tags || '').split(',').map(normalize).filter(Boolean);
          const tags4 = (this.dataset.ravinGroup4Tags || '').split(',').map(normalize).filter(Boolean);
          cache.matches = indices.flatMap((index) => index.items).filter((item) => {
            if (!item.available || !(item.variants || []).length) return false;
            const selectedOptions = [...new Set([...url.searchParams.keys()].filter((key) => key.startsWith('filter.v.option.')))];
            const tags = (item.tags || []).map(normalize);
            let percent = Number(this.dataset.ravinFallbackPercent || 0);
            if (tags1.some((tag) => tags.includes(tag))) percent = Number(this.dataset.ravinGroup1Percent || 0);
            else if (tags2.some((tag) => tags.includes(tag))) percent = Number(this.dataset.ravinGroup2Percent || 0);
            else if (tags3.some((tag) => tags.includes(tag))) percent = Number(this.dataset.ravinGroup3Percent || 0);
            else if (tags4.some((tag) => tags.includes(tag))) percent = Number(this.dataset.ravinGroup4Percent || 0);
            const price = Math.round(item.price * (1 - Math.max(0, Math.min(100, percent)) / 100));
            item.finalPrice = price;
            item.discountPercent = Math.max(0, Math.min(100, percent));
            if (selectedOptions.length) {
              return (item.variants || []).some((variant) => {
                if (variant.matched !== true) return false;
                if (!selectedOptions.every((key) => url.searchParams.getAll(key).some((selected) => {
                  if (selected.startsWith('gid://shopify/FilterSettingGroup/')) return true;
                  return optionMatches(variant[key], [selected]);
                }))) return false;
                const variantPrice = Math.round(variant.price * (1 - item.discountPercent / 100));
                return (minCents === null || variantPrice >= minCents) && (maxCents === null || variantPrice <= maxCents);
              });
            }
            return (minCents === null || price >= minCents) && (maxCents === null || price <= maxCents);
          });
          if (url.searchParams.get('sort_by') === 'price-ascending') cache.matches.sort((a, b) => a.finalPrice - b.finalPrice);
          if (url.searchParams.get('sort_by') === 'price-descending') cache.matches.sort((a, b) => b.finalPrice - a.finalPrice);
        }
        while (true) {
          const requested = cache.matches.slice((clientPage - 1) * pageSize, clientPage * pageSize);
          const pages = [...new Set(requested.filter((item) => !cache.cards.has(String(item.id))).map((item) => item.page))];
          if (!pages.length) break;
          const documents = await Promise.all(pages.map(async (page) => {
            const response = await fetch(sourcePageUrl(page), { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Unable to load products');
            return new DOMParser().parseFromString(await response.text(), 'text/html');
          }));
          documents.forEach(readCards);
          // Exclude contextual records omitted by Shopify, then refill the page.
          cache.matches = cache.matches.filter((item) => !pages.includes(item.page) || cache.cards.has(String(item.id)));
        }
      } catch (error) {
        console.error('Ravin discounted price filter:', error);
        this.ravinInitialHidden?.forEach((child) => { child.hidden = false; });
        this.ravinInitialHidden = null;
        if (this.ravinRenderVersion === renderVersion) root.removeAttribute('aria-busy');
        return false;
      }
      if (this.ravinRenderVersion !== renderVersion) return false;
      const activeOptionFilters = [...new Set([...url.searchParams.keys()].filter((key) => key.startsWith('filter.v.option.')))];
      const matchesActiveOptionFilters = (variant) => variant.matched === true && activeOptionFilters.every((key) => url.searchParams.getAll(key).some((selected) => {
        if (selected.startsWith('gid://shopify/FilterSettingGroup/')) return true;
        return optionMatches(variant[key], [selected]);
      }));
      for (const chip of this.querySelectorAll('[data-ravin-facet-param]')) {
        const parameter = chip.dataset.ravinFacetParam;
        const value = chip.dataset.ravinFacetValue;
        const supported = parameter === 'filter.p.product_type' || parameter === 'filter.p.vendor' || parameter === 'filter.p.tag' || parameter.startsWith('filter.v.option.');
        if (!supported) continue;
        const grouped = value.startsWith('gid://shopify/FilterSettingGroup/');
        const values = grouped ? colorGroups[value.split('/').pop()] : [value];
        if (!values) continue;
        const count = cache.matches.filter((item) => {
          if (!parameter.startsWith('filter.v.option.')) return (item.facets?.[parameter] || []).some((option) => optionMatches(option, values));
          return (item.variants || []).some((variant) => {
            if (!matchesActiveOptionFilters(variant) || !optionMatches(variant[parameter], values)) return false;
            const price = Math.round(variant.price * (1 - item.discountPercent / 100));
            return (minCents === null || price >= minCents) && (maxCents === null || price <= maxCents);
          });
        }).length;
        const counter = chip.querySelector('[data-ravin-facet-count]');
        if (counter) { counter.textContent = '(' + count + ')'; counter.hidden = false; }
        const isSelected = chip.getAttribute('aria-current') === 'true';
        chip.hidden = count === 0 && !isSelected;
        if (!isSelected) {
          chip.classList.toggle('disabled', count === 0);
          if (this.hasAttribute('data-refine-ready')) {
            chip.removeAttribute('aria-disabled');
            chip.dataset.ravinZeroCount = count === 0 ? 'true' : 'false';
          } else if (count === 0) chip.setAttribute('aria-disabled', 'true');
          else chip.removeAttribute('aria-disabled');
        }
      }
      const matches = cache.matches.map((item) => cache.cards.get(String(item.id)) || null);
      const start = (clientPage - 1) * pageSize;
      const visible = matches.slice(start, start + pageSize).filter(Boolean);

      // Phase 3.5: avoid discarding verified, in-stock Shopify product cards.
      // Exact ID/order matching is deliberately conservative. All existing
      // stock, size/color, discounted-price and pagination checks still run.
      const renderedCards = grid.querySelectorAll(':scope > [data-ravin-price-card]');
      const keepServerRenderedCards =
        mustBackfillAvailable && !hasDiscountedRange && !hasVariantFilters &&
        !this.ravinInitialHidden &&
        visible.length === pageSize &&
        renderedCards.length === visible.length &&
        Array.from(renderedCards).every((card, index) =>
          !card.hidden && card.dataset.ravinProductId === String(visible[index].id));

      if (!keepServerRenderedCards) {
        if (visible.length) {
          grid.innerHTML = visible.map((item) => item.html + item.editorials.join('')).join('');
        } else {
          const message = hasDiscountedRange
            ? root.dataset.ravinNoPriceResults || ''
            : root.dataset.ravinNoAvailableResults || '';
          grid.innerHTML = '<p class="ravin-price-no-results">' + message + '</p>';
        }
      }
      this.ravinInitialHidden = null;

      const sourcePagination = root.querySelector('[data-ravin-price-pagination]');
      if (sourcePagination) sourcePagination.hidden = true;
      let clientPagination = root.querySelector('.ravin-client-pagination');
      if (!clientPagination) {
        clientPagination = document.createElement('nav');
        clientPagination.className = 'ravin-client-pagination';
        clientPagination.setAttribute('aria-label', root.dataset.ravinPaginationLabel || 'Pagination');
        grid.insertAdjacentElement('afterend', clientPagination);
      }

      const pageLink = (page, label) => {
        const pageUrl = new URL(window.location.href);
        for (const key of Array.from(pageUrl.searchParams.keys())) {
          if (key === 'page' || key.startsWith('page_')) pageUrl.searchParams.delete(key);
        }
        if (page <= 1) pageUrl.searchParams.delete('ravin_page');
        else pageUrl.searchParams.set('ravin_page', String(page));
        return '<a href="' + pageUrl.toString() + '" data-ravin-client-page="' + page + '">' + label + '</a>';
      };

      const links = [];
      if (clientPage > 1) links.push(pageLink(clientPage - 1, root.dataset.ravinPreviousLabel || 'Previous'));
      const exactLastPage = cache.exhausted ? Math.max(1, Math.ceil(matches.length / pageSize)) : null;
      const lastKnownPage = exactLastPage || Math.max(clientPage + 1, Math.ceil(matches.length / pageSize));
      const firstNumber = Math.max(1, clientPage - 2);
      const lastNumber = Math.min(lastKnownPage, clientPage + 2);

      if (firstNumber > 1) {
        links.push(pageLink(1, '1'));
        if (firstNumber > 2) links.push('<span aria-hidden="true">…</span>');
      }
      for (let page = firstNumber; page <= lastNumber; page += 1) {
        if (page === clientPage) links.push('<span class="current" aria-current="page">' + page + '</span>');
        else links.push(pageLink(page, String(page)));
      }
      if (exactLastPage && lastNumber < exactLastPage) {
        if (lastNumber < exactLastPage - 1) links.push('<span aria-hidden="true">…</span>');
        links.push(pageLink(exactLastPage, String(exactLastPage)));
      } else if (!cache.exhausted) {
        links.push('<span aria-hidden="true">…</span>');
      }
      if (matches.length > clientPage * pageSize || !cache.exhausted) {
        links.push(pageLink(clientPage + 1, root.dataset.ravinNextLabel || 'Next'));
      }
      clientPagination.innerHTML = links.join('');

      const resultInfo = root.querySelector('[data-ravin-result-info]');
      if (resultInfo) {
        resultInfo.textContent = resultInfo.textContent.trim().replace(/^\d+/, String(matches.length));
        resultInfo.hidden = false;
      }
      root.removeAttribute('aria-busy');
      root.dispatchEvent(new CustomEvent('ravin:results-replaced'));
      return true;
    }
  });
}
